export default __webpack_public_path__ + "static/media/formafterclick.3eba1394.svg";